module.exports = __webpack_public_path__ + "img/txt_info1.873153dc.png";